import { Pressable, ScrollView, View, SxProp } from 'dripsy';
import { ScrollView as RnScrollView } from 'react-native';
import React, { useContext, useRef, useState } from 'react';

import { LayoutContext } from 'contexts/LayoutContext';
import { keyGenerator } from '@/utils/keyGenerator';

interface ImageSliderProps {}

export const ImageSlider: React.FC<ImageSliderProps> = ({ children }) => {
  const layout = useContext(LayoutContext);
  const [currentPage, setCurrentPage] = useState(0);
  const scrollViewRef = useRef<RnScrollView>(null);

  function toPage(page: number) {
    setCurrentPage(page);
    scrollViewRef.current?.scrollTo({
      x: page * layout.dimensions.width,
      animated: true
    });
  }

  return (
    <View>
      <ScrollView
        ref={scrollViewRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={16}
        pagingEnabled={true}
        onScroll={(event) => {
          const currentOffset = event.nativeEvent.contentOffset.x;
          const viewSize = event.nativeEvent.layoutMeasurement.width;
          const pageNum = Math.floor(currentOffset / viewSize);
          setCurrentPage(pageNum);
        }}
        scrollEnabled
        sx={{ borderRadius: 5 }}>
        {children}
      </ScrollView>
      {/* 
        Animated Sliding dots, when the user scrolls the images, the dots will slide to the next image
      */}
      {React.Children.count(children) > 1 && (
        <View sx={styles.animatedSlidingDotsContainer}>
          {React.Children.map(children, (child, index) => (
            <Pressable key={keyGenerator('carousel-btn')} onPress={() => toPage(index)}>
              <View
                sx={{
                  height: 8,
                  width: 8,
                  borderRadius: 5,
                  backgroundColor: currentPage === index ? '#2F5EA7' : '#D8D8D8'
                }}
              />
            </Pressable>
          ))}
        </View>
      )}
    </View>
  );
};

enum StyleName {
  animatedSlidingDotsContainer = 'animatedSlidingDotsContainer'
}

const styles: Record<StyleName, SxProp> = {
  animatedSlidingDotsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$2',
    marginTop: 6
  }
};
